
import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'FieldInput',
  props: {
    name: {
      type: String,
      required: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    error: {
      type: Boolean,
      required: false,
      defautl: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: false,
      default: 'text',
      validator(value: string) {
        return [
          'text',
          'password',
          'textarea',
          'email',
          'search',
          'tel',
          'file',
          'number',
          'url',
          'time',
          'date'
        ].includes(value);
      }
    }
  },
  setup() {
    const isPwd = ref(false);
    return {
      isPwd
    };
  }
});
